import { ApiService } from './api.service';
import { IReportTemplate } from '@shared/interfaces';
import { inject, Injectable } from '@angular/core';
import { isObject } from 'lodash-es';
import { IQueryReportTemplate } from '../interfaces/queries/IQueryReportTemplate';
import { convertQueryToParams } from '../helpers/query-converter';
import { IPaginatedResult } from '../interfaces/mailing/IPaginatedResult';
import { IS_PRODUCT_SAFETY_PROJECT, IS_TRS_PROJECT } from '../../../current-project';

@Injectable({
    providedIn: 'root'
})
export class ReportTemplateService {
    private readonly apiUrl = '/templates';
    private readonly apiService = inject(ApiService);

    public getItem(id: string): Promise<IReportTemplate> {
        return this.apiService.get(`${this.apiUrl}/${encodeURIComponent(id)}`);
    }

    public getAllItems(): Promise<IReportTemplate[]> {
        return this.apiService.get(`${this.apiUrl}`);
    }

    public getAllItemsPaged(query?: IQueryReportTemplate): Promise<IPaginatedResult<IReportTemplate>> {
        return this.apiService.get(`${this.apiUrl}/paged${convertQueryToParams<IQueryReportTemplate>(query)}`);
    }

    createItem(item: IReportTemplate): Promise<IReportTemplate> {
        return this.apiService.post(this.apiUrl, this.formObject(item));
    }

    public updateItem(item: IReportTemplate): Promise<IReportTemplate> {
        if (IS_TRS_PROJECT) {
            return this.apiService.patch(this.apiUrl, this.formObject(item));
        }

        if (IS_PRODUCT_SAFETY_PROJECT) {
            return this.apiService.post(this.apiUrl, this.formObject(item));
        }
    }

    deleteItem(title: string): Promise<boolean> {
        return this.apiService.delete(`${this.apiUrl}/${encodeURIComponent(title)}`);
    }

    formObject(item: any): any {
        for (const prop of Object.keys(item)) {
            if (!item[prop]) {
                delete item[prop];
            }

            if (Array.isArray(item[prop])) {
                const resultArray: Array<any> = item[prop].filter(e => e);
                if (resultArray.length > 0) {
                    item[prop] = resultArray.map(e => this.formObject(e));
                } else {
                    delete item[prop];
                }
            } else if (isObject(item[prop])) {
                item[prop] = this.formObject(item[prop]);
            }
        }
        return item;
    }
}
